import { render } from "./termsAr.vue?vue&type=template&id=b835e646"
import script from "./termsAr.vue?vue&type=script&lang=js"
export * from "./termsAr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__